import { BillBasic } from '@enview/interface/types/bills/Bill';
import PersonVote from '@enview/interface/types/votes/PersonVote';
import PersonVoteOption from '@enview/interface/types/votes/PersonVoteOption';
import { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { trackClickedBillNumberInVoteHistory } from '../../analytics/PersonAnalytics';
import { State } from '../../dux/@types';
import ActivityCard, {
  ActivityCardStyle,
} from '../Shared/ActivityFeed/ActivityCards/ActivityCard';
import VoteIcon from '../Shared/Icons/VoteIcon';

type PersonVoteCardProps = {
  personVote: PersonVote;
};

const PersonVoteCard = (props: PersonVoteCardProps): ReactElement => {
  const { personVote } = props;
  const orgUser = useSelector((state: State) => state.account.organizationUser);

  const map = {
    [PersonVoteOption.Yes]: 'Yes',
    [PersonVoteOption.No]: 'No',
    [PersonVoteOption.Other]: 'Excused',
  };

  const date = new Date(personVote.billVote.startDate).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'utc',
  });

  const getVoteText = (): ReactElement => (
    <span className="person-vote-text">
      {personVote.personName} voted{' '}
      <span className={`person-vote-option option-${personVote.option.toLowerCase()}`}>
        {map[personVote.option]}
      </span>
    </span>
  );

  const trackBillNumberClicked = (bill: BillBasic): void => {
    trackClickedBillNumberInVoteHistory(personVote, bill, orgUser);
  };

  const bill = personVote.billVote.bill;
  const voteTitleContent = (
    <div className="vote-title">
      <div>
        <Link
          className="bill-link"
          onClick={() => trackBillNumberClicked(bill)}
          to={`/legislative-tracking/bill/details/bill-activity/${bill.id}/`}
        >
          {bill.number}
        </Link>
        <div
          className={`badge btn-sm toggle vote-result-toggle ${personVote.billVote.result}`}
        >
          <span>{personVote.billVote.result}</span>
        </div>
      </div>
      <div className="vote-context">Bill</div>
    </div>
  );

  return (
    <div>
      {getVoteText()}
      <ActivityCard
        activityStyle={ActivityCardStyle.PERSON_VOTE}
        icon={<VoteIcon />}
        iconColor="teal"
        pretitle={date}
        title={<div>{voteTitleContent}</div>}
      />
    </div>
  );
};

export default PersonVoteCard;
